module.exports = __webpack_public_path__ + "img/4.df3e6219.png";